import { render, staticRenderFns } from "./AddReportCustom.vue?vue&type=template&id=bf9f7770"
import script from "./AddReportCustom.vue?vue&type=script&lang=js"
export * from "./AddReportCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports